import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  UnorderedList,
  ListItem,
  Flex } from
'@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
export function TermsOfServicePage() {
  return (
    <Box
      as="section"
      py={{
        base: 12,
        md: 20
      }}>
      
      <Container maxW="container.xl" px={4}>
        <Box maxW="3xl" mx="auto">
          <Flex
            as={RouterLink}
            to="/"
            display="inline-flex"
            align="center"
            gap={2}
            fontSize="sm"
            fontWeight="semibold"
            color="gray.400"
            _hover={{
              color: 'white'
            }}
            transition="colors 0.2s"
            mb={10}>
            
            <ArrowLeft size={16} />
            Back to Homepage
          </Flex>

          <Heading
            as="h1"
            fontSize={{
              base: '3xl',
              md: '4xl'
            }}
            fontWeight="bold"
            mb={2}>
            
            Terms of Service
          </Heading>
          <Text fontSize="sm" color="gray.500" mb={10}>
            Last updated: April 8, 2026
          </Text>

          <VStack
            spacing={8}
            align="stretch"
            color="gray.300"
            lineHeight="relaxed">
            
            {[
            {
              title: '1. Acceptance of Terms',
              content:
              'By accessing or using GMCRadar ("Service"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, you may not use the Service. We reserve the right to update these Terms at any time, and your continued use of the Service constitutes acceptance of any changes.'
            },
            {
              title: '2. Description of Service',
              content:
              'GMCRadar provides Google Merchant Center compliance scanning, product-level risk detection, and monitoring tools. The Service analyses publicly accessible web pages and product listings to identify potential policy compliance issues. GMCRadar does not guarantee reinstatement of suspended accounts or prevention of future suspensions.'
            },
            {
              title: '3. Account Registration',
              content:
              'To access certain features, you may be required to create an account. You agree to provide accurate, current, and complete information during registration and to keep your account information updated. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.'
            },
            {
              title: '5. Intellectual Property',
              content:
              'All content, features, and functionality of the Service — including but not limited to text, graphics, logos, and software — are the exclusive property of GMCRadar and are protected by copyright, trademark, and other intellectual property laws. You may not copy, modify, or distribute any part of the Service without prior written consent.'
            },
            {
              title: '6. Disclaimer of Warranties',
              content:
              'The Service is provided "as is" and "as available" without warranties of any kind, either express or implied. GMCRadar does not warrant that the Service will be uninterrupted, error-free, or that any results obtained from the Service will be accurate or reliable. Use of the Service is at your sole risk.'
            },
            {
              title: '7. Limitation of Liability',
              content:
              'To the fullest extent permitted by law, GMCRadar shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, or business opportunities, arising out of or in connection with your use of the Service.'
            },
            {
              title: '8. Termination',
              content:
              'We may suspend or terminate your access to the Service at any time, with or without cause, and with or without notice. Upon termination, your right to use the Service will immediately cease. All provisions of these Terms that by their nature should survive termination shall survive.'
            },
            {
              title: '9. Governing Law',
              content:
              'These Terms shall be governed by and construed in accordance with applicable laws, without regard to conflict of law principles. Any disputes arising from these Terms or the Service shall be resolved through binding arbitration.'
            },
            {
              title: '10. Contact',
              content:
              'If you have any questions about these Terms, please contact us through the Request Access page or reach out to our support team.'
            }].
            map((section, i) =>
            <Box key={i}>
                <Heading
                as="h2"
                fontSize="xl"
                fontWeight="bold"
                color="white"
                mb={3}>
                
                  {section.title}
                </Heading>
                <Text>{section.content}</Text>
              </Box>
            )}

            <Box>
              <Heading
                as="h2"
                fontSize="xl"
                fontWeight="bold"
                color="white"
                mb={3}>
                
                4. Acceptable Use
              </Heading>
              <Text mb={3}>You agree not to:</Text>
              <UnorderedList
                spacing={2}
                color="gray.400"
                stylePosition="inside">
                
                <ListItem>
                  Use the Service for any unlawful purpose or in violation of
                  any applicable laws
                </ListItem>
                <ListItem>
                  Attempt to reverse-engineer, decompile, or disassemble any
                  part of the Service
                </ListItem>
                <ListItem>
                  Use automated systems to access the Service in a manner that
                  exceeds reasonable use
                </ListItem>
                <ListItem>
                  Resell, redistribute, or sublicense access to the Service
                  without written permission
                </ListItem>
                <ListItem>
                  Interfere with or disrupt the integrity or performance of the
                  Service
                </ListItem>
              </UnorderedList>
            </Box>
          </VStack>
        </Box>
      </Container>
    </Box>);

}